const createLoadingLocksManager = (defaultTimeout = 15000) => {
  const locks: Record<
    string,
    {
      count: number;
      timeoutId?: ReturnType<typeof setTimeout>;
    }
  > = {};

  const updateGlobalCursor = () => {
    const hasActiveLocks = Object.values(locks).some(lock => lock.count > 0);
    document.body.style.cursor = hasActiveLocks ? "wait" : "default";
  };

  const forceClear = (lockId: string) => {
    const lock = locks[lockId];
    if (!lock) return;

    lock.count = 0;

    if (lock.timeoutId) {
      clearTimeout(lock.timeoutId);
      lock.timeoutId = undefined;
    }

    const el = document.getElementById(lockId);
    if (el) el.style.pointerEvents = "auto";

    updateGlobalCursor();
  };

  const start = (lockId: string = "root") => {
    if (!locks[lockId]) {
      locks[lockId] = { count: 0 };
    }

    const lock = locks[lockId];
    lock.count += 1;

    if (lock.timeoutId) {
      clearTimeout(lock.timeoutId);
    }

    lock.timeoutId = setTimeout(() => {
      forceClear(lockId);
    }, defaultTimeout);

    const el = document.getElementById(lockId);
    if (el) el.style.pointerEvents = "none";

    updateGlobalCursor();
  };

  const stop = (lockId: string = "root") => {
    const lock = locks[lockId];
    if (!lock) return;

    lock.count = Math.max(lock.count - 1, 0);

    if (lock.count === 0) {
      if (lock.timeoutId) {
        clearTimeout(lock.timeoutId);
        lock.timeoutId = undefined;
      }

      const el = document.getElementById(lockId);
      if (el) el.style.pointerEvents = "auto";
    }

    updateGlobalCursor();
  };

  const reset = () => {
    Object.keys(locks).forEach(lockId => {
      const lock = locks[lockId];

      if (lock.timeoutId) {
        clearTimeout(lock.timeoutId);
      }

      const el = document.getElementById(lockId);
      if (el) el.style.pointerEvents = "auto";
    });

    document.body.style.cursor = "default";

    for (const k in locks) {
      delete locks[k];
    }
  };

  return {
    start,
    stop,
    reset,
  };
};

export const loadingLocksManager = createLoadingLocksManager();
